// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxxxlargeOnConfiend-badge-925faf9f"};